"use client"

import {useEffect, useState} from "react";
import {WalkPath, WalkStatus} from "@/types/Walk";
import {pathStatusRequest} from "@/utils/api/PathStatus";
import {useAppStore} from "@/store/AppStore";

export default function usePathStatus(token?: string, segment?: WalkPath | number) {
  const {path_id} = typeof segment === "number" ? {path_id: segment} : segment || {}
  const [data, setData] = useState<WalkStatus | undefined>(undefined)
  const setRefresh = useAppStore((state) => state.setRefresh);

  useEffect(() => {
    const fetchData = async (token: string) => {
      const fetched = await pathStatusRequest(token, String(path_id))
      if (false === fetched) {
        setRefresh(true)
        return true
      }
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data && path_id && token) {
      fetchData(token)
    }
  }, [setRefresh, token, path_id, data])

  return data
}
